import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { whitePvcDict } from "@/lib/shop/products/white-pvc";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/shop_/white-pvc")({
  head: () => ({
    ...buildProductHead(whitePvcDict),
    links: alternateLinkList("/shop/white-pvc", "en"),
  }),
  component: () => <ProductPage dict={whitePvcDict} />,
});